<template>
  <div class="filter-overlay">
    <div class="reveal-content">
      <div class="overlay-title-container">
        <button class="button btn-back" aria-label="Close alert" type="button" @click="$emit('close-reveal')">
          <font-awesome-icon :icon="['fas', 'chevron-left']"/>
        </button>
      </div>

      <div class="filter-block-label">{{ $t('filterLabels.radius') }}</div>

      <label class="slider-value-display">{{ displayValue }}</label>
      <vue-slider ref="slider" v-model="range" :min="10" :max="150" clickable tooltip="none" :interval="10" :dotStyle="{ width: '1.25rem', height: '1.25rem' }"/>

      <label class="filter-block-label">{{ $t('filterLabels.category') }}</label>
      <fieldset class="categories-filter filter-block">
        <div class="category-item filter-item" v-for="cat in entityCategories" :key="`cat-${cat.id}`">
          <input :id="`category-${cat.id}`" type="checkbox" :value="cat.id" v-model="checkedCategories">
          <label :for="`category-${cat.id}`">{{ cat.name }}</label>
        </div>
      </fieldset>

      <label class="filter-block-label">{{ $t('filterLabels.criterias') }}</label>
      <fieldset class="criterias-filter filter-block">
        <div class="critera-item filter-item" v-for="criteria in criterias" :key="`criteria-${criteria.id}`">
          <input :id="`criteria-${criteria.id}`" type="checkbox" :value="criteria.id" v-model="checkedCriterias">
          <label :for="`criteria-${criteria.id}`">{{ criteria.name }}</label>
        </div>
      </fieldset>

      <!-- <label class="filter-block-label">{{ $t('companyList.destinations') }}</label>
       <fieldset class="top-performance-container filter-block" v-show="enableTopPerformance">
         <input id="cb-top-performance" type="checkbox" v-model="onlyTopPerformanceEntities">
         <label for="cb-top-performance">{{ $t('filterLabels.topPerformanceCheckbox') }}</label>
       </fieldset>
 -->
      <div class="actions-container">
        <div class="show-results-btn-container btn-container">
          <button class="button expand btn-show-results" aria-label="Close alert" type="button" @click="$emit('close-reveal')">
            <span class="btn-text">{{ $t('filterLabels.showResults') }}</span>
            <span>({{ count }})</span>
            <img src="@/assets/svgs/2024/icons/arrow-big.svg" alt="ok">
          </button>
        </div>
        <div class="reset-btn-container btn-container">
          <button type="button" @click="resetAllFilters" class="btn-reset">
            <img src="@/assets/svgs/2024/icons/reset-close.svg" alt="reset">
            {{ $t('filterLabels.resetFilters') }}
          </button>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component'
import foundation from '@/mixins/foundation'

export default {
  name: 'FilterOverlay',
  mixins: [foundation],
  components: {
    VueSlider
  },
  props: {
    entities: {
      type: String,
      default: ''
    },
    enableCategories: {
      type: Boolean,
      default: false
    },
    enableCriterias: {
      type: Boolean,
      default: false
    },
    enableRange: {
      type: Boolean,
      default: false
    },
    enableTopPerformance: {
      type: Boolean,
      default: false
    },
    entityCategories: {
      type: Array,
      default() {
        return []
      }
    },
    criterias: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      count: 0,
      range: 150,
      checkedCategories: [],
      checkedCriterias: [],
      onlyTopPerformanceEntities: false
    }
  },
  computed: {
    allowRange() {
      if (this.$store.state.currentPosition && this.enableRange) {
        return true
      } else {
        return false
      }
    },
    filteredResultsCount() {
      return this.$store.getters.getFilteredResultsCount(this.entities)
    },
    selectedRange() {
      if (this.enableRange) {
        return this.$store.getters.getSelectedRange(this.entities)
      }
      return 0
    },
    selectedCategories() {
      if (this.enableCategories) {
        return this.$store.getters.getSelectedCategories(this.entities)
      }
      return []
    },
    selectedCriterias() {
      if (this.enableCriterias) {
        return this.$store.getters.getSelectedCriterias(this.entities)
      }
      return []
    },
    allowOnlyTopPerformanceEntities() {
      if (this.enableTopPerformance) {
        return this.$store.getters.getTopPerformanceState(this.entities)
      }
      return false
    },
    displayValue() {
      if (this.range <= 140) {
        return `< ${this.range} km`
      } else {
        return `> ${this.range} km`
      }
    }
  },
  watch: {
    filteredResultsCount: function(count) {
      this.count = count
    },
    checkedCategories: function(checkedCategories) {
      this.$store.dispatch('updateSelectedCategories', {entity: this.entities, categories: checkedCategories})
    },
    checkedCriterias: function(checkedCriterias) {
      this.$store.dispatch('updateSelectedCriterias', {entity: this.entities, criterias: checkedCriterias})
    },
    onlyTopPerformanceEntities: function(tps) {
      this.$store.dispatch('updateTopPerformanceSelection', {entity: this.entities, newState: tps})
    },
    range: function(newValue) {
      this.$store.dispatch('updateSelectedRange', {entity: this.entities, newRange: newValue})
    }
  },
  methods: {
    resetAllFilters() {
      this.$store.dispatch('resetFilter', {entity: this.entities})

      this.count = 0
      this.range = 150
      this.checkedCategories = []
      this.checkedCriterias = []
      this.onlyTopPerformanceEntities = false

      this.$emit('reset-filters')
    }
  },
  mounted() {
    // init cats
    this.selectedCategories.forEach(cat => {
      this.checkedCategories.push(cat.id)
    }, this)
    this.selectedCriterias.forEach(criteria => {
      this.checkedCriterias.push(criteria.id)
    }, this)
    this.onlyTopPerformanceEntities = this.allowOnlyTopPerformanceEntities
    this.count = this.filteredResultsCount
    this.range = this.selectedRange
  }
}
</script>

<style lang="scss">
.vue-slider {
  .vue-slider-rail,
  .vue-slider-process {
    height: 2px;
    background-color: $dark-gray !important;
  }
  .vue-slider-dot {
    width: 1.25rem !important;
    height: 1.25rem !important;

    .vue-slider-dot-handle {
      border: 4px solid $dark-gray !important;
    }
  }
}
label.slider-value-display {
  margin-bottom: .5rem !important;
  text-align: left;
  font-weight: bold !important;
  font-size: 1rem !important;
  color: $dark-gray !important;
}
</style>

<style lang="scss" scoped>
@import '~vue-slider-component/theme/antd.css';

.filter-overlay {
  padding: 0 !important;
  background-color: $light-gray;
  display: block;
  opacity: 0;
  visibility: hidden;
  transition: all .15s ease-in-out;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -2;

  &.is-reveal-open {
    z-index: 1000;
    background-color: rgba($black, .8);
    opacity: 1;
    visibility: visible;

    .reveal-content {
      visibility: visible;
      opacity: 1;
    }
  }

  .reveal-content {
    background-color: $white;
    visibility: hidden;
    opacity: 0;
    overflow-y: scroll;
    padding: 1rem;

    height: 100vh;

    @include breakpoint(medium) {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      max-width: rem-calc(530);

      height: auto;
    }
  }

  .filter-block-label {
    font-weight: bold;
    font-size: 1.2rem;
    display: block;
    margin: 1.1rem 0;
  }

  .overlay-title-container {
    /*@include xy-gutters($gutter-type: padding, $gutter-position: top left right);
    display: flex;
    justify-content: flex-start;
    align-items: center;
     */
    margin-bottom: rem-calc(54);

    /*.overlay-title {
      margin-left: 1rem;
      font-size: rem-calc(12);
      font-weight: 600;
      text-transform: uppercase;
    }*/
  }

  .filter-block {
    display: flex;
    flex-wrap: wrap;

    input {
      display: none;
    }

    label {
      background-color: $light-gray;
      border-radius: 50px;
      font-weight: bold;
      border: 1px solid $medium-gray;
      color: $dark-gray;
      margin: 2px 5px 2px 0;
      height: rem-calc(48px);
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 14px 18px;
    }

    input:checked + label {
      background-color: $dark-gray;
      border-color: $dark-gray;
      color: $white;
    }
  }

  .actions-container {
    margin-top: 1rem;
    padding: 1rem;

    > .btn-container {
      padding-top: 1rem;
    }

    .btn-container {

      img {
        height: 20px;
      }

      &.reset-btn-container {
        text-align: center;

        .btn-reset {
          cursor: pointer;
          color: $dark-gray;

          img {
            margin-right: .5rem;
          }
        }
      }

      &.show-results-btn-container {
        text-align: center;
        .btn-show-results {
          min-width: rem-calc(250);
          color: $dark-gray;
          padding: 14px 18px;
          border: 3px solid $dark-gray;
          background: $white;
          border-radius: 20rem;
          font-weight: bold;

          /*.btn-text {
            margin-right: 0.2rem
          }*/

          &:hover {
            border-color: $light-gray;
            background: $light-gray;
          }

          img {
            margin-left: 1rem;
          }
        }
      }
    }
  }
}
</style>